var map = {
	"./br/PT/S1/bg76.png": 46027,
	"./br/PT/bg76.png": 27198,
	"./in/EN/S1/bg76.png": 14505,
	"./ph/EN/S1/bg76.png": 72344,
	"./ph/EN/bg76.png": 86770,
	"./vn/VI/S1/bg76.png": 83506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86930;